<template>
  <div>
    <div style="display: flex">
      <div style="width: 60%; text-align: ceter">
        湘江国投湖南省私募基金管理平台
      </div>
      <div style="width: 40%">
        <Towntreeselect
          style="width: 60%; text-align: ceter"
          v-bind:opt="TownList"
          v-on:getFtcode="getFtcode"
        ></Towntreeselect>
      </div>
    </div>
    <div><Myswiper v-bind:opt="PageConfigList"></Myswiper></div>
    <div>小镇简介</div>
    <div>
      <MapEcharts></MapEcharts>
    </div>
  </div>
</template>
<script>
import MapEcharts from "./MapEcharts";
import Myswiper from "./swiper";
import Towntreeselect from "./treeselect.vue";
import { getAllTownList, getPageConfigListMain } from "@/common/js/api.js";
export default {
  // name: "TownIndex",
  components: {
    MapEcharts,
    Myswiper,
    Towntreeselect,
  },
  data() {
    return {
      TownList: [],
      PageConfigList: [],
      ruleForm: {
        ftCode: "",
      },
    };
  },
  methods: {
    //基金小镇下拉框，默认选中列表第一个
    async getTownList() {
      const { result } = await getAllTownList();
      console.log(result);
      let TownListAll = [];
      for (var prop in result) {
        const town = { id: 0, label: "", children: [] };
        town.id = prop;
        town.label = prop;
        result[prop].forEach(function (TownList1, index) {
          const Townchildren = { id: 0, label: "" };
          Townchildren.id = TownList1.ftCode;
          Townchildren.label = TownList1.ftName;
          town.children.push(Townchildren);
        });
        TownListAll.push(town);
      }
      this.TownList = TownListAll;
      this.ruleForm.ftCode = TownListAll[0].children[0].id;
    },
    getFtcode(data) {
      this.ruleForm.ftCode = data;
    },
    //获取页面配置
    async getPageConfigList() {
      let params = {
        page: "",
      };
      const { result } = await getPageConfigListMain(params).catch();
      console.log(result);
      this.PageConfigList = result;
    },
  },
  mounted() {
    // 获取小镇列表
    this.getTownList();
    this.getPageConfigList();
  },
};
</script>
